import { createSlice } from "@reduxjs/toolkit";
import { fetchDistrictInchargeInstock } from "./thunk";

interface InstockState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: InstockState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DistrictInchargeInstockSlice = createSlice({
  name: "DistrictInchargeInstock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistrictInchargeInstock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistrictInchargeInstock.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDistrictInchargeInstock.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch District Incharge Instock Log";
      });
  },
});

export default DistrictInchargeInstockSlice.reducer;
